import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { coPath, toWire, withIdempotencyKey } from './shared';

/** GET `…/collection-refunds`：收款沖銷／退款／退款沖銷事件（依時間）。 */
export async function fetchCollectionCashEvents(id) {
  const { data: raw } = await request.get(coPath(id, '/collection-refunds'));
  return parseVer4DetailResponse(raw);
}

/**
 * POST `…/collection-refunds`（REFUND）：`sourceReceiptId`、`amount`、`actualOccurredAt`、`reason`、
 * `expectedReceiptAvailable`、`phaseReversals[{ phaseId, amount, expectedCreditedAmount }]`、
 * `salesReversals[{ sourceAllocationId, salesOrderId, amount, expectedAllocatedAmount }]`。
 */
export async function createCollectionRefund(id, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    coPath(id, '/collection-refunds'),
    toWire(payload),
    withIdempotencyKey(idempotencyKey),
  );
  return parseVer4DetailResponse(raw);
}

/** POST `…/collection-refunds/{refundId}/void`（REFUND_VOID）：`{ actualOccurredAt, reason }`。 */
export async function voidCollectionRefund(id, refundId, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    coPath(id, `/collection-refunds/${refundId}/void`),
    toWire(payload),
    withIdempotencyKey(idempotencyKey),
  );
  return parseVer4DetailResponse(raw);
}
